/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import ScreenContainerSimpleLayoutConnexion from 'layouts/ScreenContainerSimpleLayoutConnexion'
import ErrorBody from './ErrorBody'
import ROUTES from '../../utils/ROUTES'

interface Props {
  title: string
  description: string | JSX.Element
  type: string
  chatbot?: boolean
  textButton?: string
  externalLink?: string
  connected: boolean
}

const ErrorInfo: React.FC<Props> = ({
  title,
  description,
  type,
  chatbot,
  textButton,
  externalLink,
  connected,
}: Props) => {
  const history = useHistory()
  const [countdown, setCountdown] = useState<number | null>(null)

  useEffect(() => {
    if (type !== 'deniedAccess' || !connected) return undefined

    const totalSeconds = 10
    setCountdown(totalSeconds)
    const intervalId = setInterval(() => {
      setCountdown((prev) => {
        if (prev === null) return null
        if (prev <= 1) {
          clearInterval(intervalId)
          history.push(ROUTES.Home)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(intervalId)
  }, [type, connected, history])

  return (
    <ScreenContainerSimpleLayoutConnexion isLogged={connected}>
      <ErrorBody
        title={title}
        description={description}
        type={type}
        chatbot={chatbot}
        textButton={textButton}
        externalLink={externalLink}
        countdown={countdown}
      />
    </ScreenContainerSimpleLayoutConnexion>
  )
}

ErrorInfo.defaultProps = {
  chatbot: true,
  textButton: undefined,
  externalLink: undefined,
}

export default ErrorInfo
